import type { ReactNode } from "react";
import { Tag } from "antd";

/** Sắc trạng thái theo token UIUX baseline v2.0 và Design Tokens chuẩn hóa. */
export type Tone =
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "neutral"
  | "national"
  | "memorial-gold";

/** Bảng ánh xạ tone → cặp token color/bg/border qua CSS var — không hard-code hex. */
const TONE_TOKENS: Record<Tone, { readonly color: string; readonly bg: string; readonly border?: string }> = {
  info: { color: "var(--ncc-color-status-info)", bg: "var(--ncc-color-status-info-bg)" },
  success: { color: "var(--ncc-color-status-success)", bg: "var(--ncc-color-status-success-bg)" },
  warning: { color: "var(--ncc-color-status-warning)", bg: "var(--ncc-color-status-warning-bg)" },
  danger: { color: "var(--ncc-color-status-danger)", bg: "var(--ncc-color-status-danger-bg)" },
  neutral: { color: "var(--ncc-color-text-secondary)", bg: "var(--ncc-color-bg-subtle)" },
  national: {
    color: "var(--ncc-badge-national-text, var(--ncc-color-accent-national))",
    bg: "var(--ncc-badge-national-bg, var(--ncc-primitive-red-50))",
    border: "var(--ncc-badge-national-border, var(--ncc-primitive-red-300))",
  },
  "memorial-gold": {
    color: "var(--ncc-primitive-gold-600)",
    bg: "var(--ncc-primitive-amber-50)",
    border: "var(--ncc-primitive-amber-300)",
  },
};

/**
 * Nhãn trạng thái dùng chung (UIUX §3 Status Badge): LUÔN có text, kèm icon khi
 * caller truyền — trạng thái không bao giờ chỉ biểu thị bằng màu.
 */
export function StatusBadge({ tone, label, icon }: {
  readonly tone: Tone;
  readonly label: string;
  readonly icon?: ReactNode;
}) {
  const tokens = TONE_TOKENS[tone] ?? TONE_TOKENS.neutral;
  return (
    <Tag
      style={{
        color: tokens.color,
        background: tokens.bg,
        borderColor: tokens.border ?? tokens.color,
        display: "inline-flex",
        alignItems: "center",
        gap: "var(--ncc-spacing-xs)",
        marginInlineEnd: 0,
      }}
    >
      {icon}
      {label}
    </Tag>
  );
}
